import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '@inshuwa-client/models';
// Concrete path rather than the 'core' barrel: this pipe is declared in an eagerly loaded module.
import { formatMoneyValue } from '../utils/currency-display.state';

@Pipe({
  name: 'icCurrency',
  // Impure so changing the setting repaints every amount on screen. The formatter is cached, so a
  // run costs one Map lookup plus the Intl format the old pure version paid on every call anyway.
  pure: false,
})
export class IcCurrencyPipe implements PipeTransform {
  /**
   * Positional drop-in for Angular's currency pipe, which most of these call sites came from.
   * `display` is accepted and ignored: symbol-vs-code is the user's setting now, not the template's.
   */
  transform(
    value: number | string | null | undefined,
    currency?: Currency | string | null,
    display?: string,
    digitsInfo?: string,
  ): string {
    return formatMoneyValue(value, currency, digitsInfo);
  }
}

@Pipe({ name: 'abbreviateNumber' })
export class AbbreviateNumberPipe implements PipeTransform {
  transform(value: number, ...args: any[]): any {
    if (value < 1e3) return value;
    if (value >= 1e3 && value < 1e6) return +(value / 1e3).toFixed(1) + 'K';
    if (value >= 1e6 && value < 1e9) return +(value / 1e6).toFixed(1) + 'M';
    if (value >= 1e9 && value < 1e12) return +(value / 1e9).toFixed(1) + 'B';
    if (value >= 1e12) return +(value / 1e12).toFixed(1) + 'T';
  }
}
